<template>
	<div id="usuario">
		<a-row type="flex" justify="space-between" align="bottom">
			<a-col :span="20">
				<a-input-search
					v-model="strSearch"
					:maxLength=100
					placeholder="Insira o nome a ser pesquisado"
					@search="onSearch"					
					:disabled="loading"
				>
					<a-button slot="enterButton" type="primary" :disabled="loading">Pesquisar</a-button>
				</a-input-search>
			</a-col>
			<a-col :span="4" style="text-align: right;">
				<a-button
					type="primary"
					class="tr-search-btn"
					style="width: 130px;"
					@click.stop.prevent="onNewUsuario"
					:disabled="loading"
					v-if="habilitarFuncionalidade('PermitirIncluir')"
				>Novo Usuário</a-button>
			</a-col>
		</a-row>

		<a-row style="height: calc(100vh - 230px); overflow-y: auto; overflow-x: auto; min-height: 100px;">
			<a-table
				:columns="showFornecedor? columns: columnsSemCliente"
				:rowKey="record => record.idUsuario"
				:dataSource="data"
				:loading="{spinning:loading, tip:'Carregando...'}"
				:pagination="pagination"
				@change="handleTableChange"
				size="middle"
			>
				<!-- <template
					slot="idPerfilFornecedor"
					slot-scope="idPerfilFornecedor, record"
				>{{record.idPerfilFornecedor === 1 ? 'Dado' : 'Autos'}}</template> -->
				<template slot="ativo" slot-scope="ativo, record">					
					<a-icon type="check-circle" class="sucess" v-if="record.ativo"/>
					<a-icon type="close-circle" class="danger" v-else/>					
				</template>				
				<template slot="editar" slot-scope="editar, record">
					<div>
						<a-tooltip>
							<template slot="title">Editar usuário</template>
							<a-icon 
								type="form" 
								class="cursor" 
								v-if="(habilitarFuncionalidade('PermitirAlterar'))"
								@click="editarUsuario(record)"/>
						</a-tooltip>
					</div>
				</template>
			</a-table>

			<modal-component
				class="modal-component"
				title="Editar Usuário"
				ref="modaluser"
				width="40%"
				:maskClosable="false"
			>
				<a-row>
					<span class="tr-label">Nome:</span>
					<a-input
						:maxLength=100
						placeholder="Insira o nome do usuário"
						v-model="user.nome"
						v-ant-input-focus
						:allowClear="user.nome!=''"
					>
						<a-icon slot="prefix" type="user"/>
					</a-input>
				</a-row>
				<a-row>
					<span class="tr-label">E-mail:</span>					
					<a-input 
						:maxLength=100
						placeholder="Insira o e-mail do usuário" 
						v-model="user.email"
						:allowClear="user.email!=''"
						@change="lowerCaseEmail"
					>
						<a-icon slot="prefix" type="mail"/>
					</a-input>
				</a-row>
				<a-row>
					<span class="tr-label">Login:</span>					
					<a-input 
						:maxLength=50
						placeholder="Insira o login do usuário. (Ex: nome.sobrenome)"
						v-model="user.login"
						:allowClear="user.login!=''"
						@change="lowerCaseLogin"
						:disabled="!ehNovoUsuario"
						readOnly
					>
						<a-icon slot="prefix" type="team"/>
					</a-input>
				</a-row>
				<a-row>
					<a-col :span="24">
						<span class="tr-label">Tipo Acesso:</span>						
						<a-select
							placeholder="Selecione o tipo acesso do usuário"
							:value="valuePerfilPortal"
							style="width: 100%;"
							@change="handleSelectChange"
						>
							<a-select-option
								v-for="perfilPortal in perfisPortal"
								:key="perfilPortal.idPerfilPortal"
								:value="perfilPortal.idPerfilPortal"
							>{{perfilPortal.descricao}}</a-select-option>
						</a-select>
					</a-col>
				</a-row>
				<a-row v-if="(valuePerfilPortal==3)">
					<span class="tr-label">CNPJ/CPF:</span>					
					<a-input
						:maxLength=20
						placeholder="Insira o CNPJ/CPF"
						v-model="user.cnpj"
						v-ant-input-focus
						:allowClear="user.cnpj!=''"
						>
						<!-- v-mask="'##.###.###/####-##'" -->
						<a-icon slot="prefix" type="user"/>						
					</a-input>
					<!--<a-col :span="24">
							<span class="tr-label">Tipo Perfil:</span>						
							<a-select
								placeholder="Selecione o tipo de crendecial"
								style="width: 100%;"
								v-model="user.tipoPerfil"
								@change="handleSelecttipoPerfilChange"
							>
								<a-select-option
									v-for="tptipoPerfil in tptipoPerfilData"
									:key="tptipoPerfil.key"
									:value="tptipoPerfil.key"
								>{{tptipoPerfil.descricao}}</a-select-option>
							</a-select>
						</a-col>-->
				</a-row>	
				<span slot="buttons">
					<a-row type="flex" align="middle">
						<a-col :span="12" style="text-align: left;">
							<a-switch style="margin-left: 15px;" defaultChecked v-model="user.ativo" @change="handlerSwitchChange" :disabled="$store.state.auth.idPerfilPortal == 5">
								<a-icon type="check" slot="checkedChildren"/>
								<a-icon type="close" slot="unCheckedChildren"/>
							</a-switch>
							<span style="margin-left: 10px;" v-if="user.ativo">Ativo</span>
							<span style="margin-left: 10px;" v-else>Inativo</span>
							<a-tooltip>
								<template slot="title">Ao desativar o usuário, todos os perfis e fontes vinculados a ele serão desativados consequentemente</template>
								<a-icon type="info-circle" style="margin-left: 10px; color: #1d375c;"/>
							</a-tooltip>
						</a-col>
						<a-col :span="12">
							<a-row type="flex" justify="end" align="middle" :gutter="40">
								<a-col>
									<a-button key="back" class="usuario-form-button" @click.prevent="handleCancelEditUser">Retornar</a-button>
								</a-col>
								<a-col>
									<a-button
										key="submit"
										class="usuario-form-button"
										type="primary"
										v-if="habilitarFuncionalidade('PermitirAlterar')"
										@click.prevent="handleOkEditUser"
									>Salvar</a-button>
								</a-col>
							</a-row>
						</a-col>
					</a-row>
				</span>
			</modal-component>

			<modal-component
				class="modal-component"				
				title="Novo Usuário"
				ref="modalnewuser"
				width="40%"
				:maskClosable="false"
			>
				<a-row>
					<span class="tr-label">Nome:</span>					
					<a-input
						:maxLength=200
						placeholder="Insira o nome do usuário"
						v-model="user.nome"
						v-ant-input-focus
						:allowClear="user.nome!=''"
					>
						<a-icon slot="prefix" type="user"/>						
					</a-input>
				</a-row>
				<a-row>
					<span class="tr-label">E-mail:</span>					
					<a-input 
						:maxLength=100
						placeholder="Insira o e-mail do usuário" 
						v-model="user.email"
						:allowClear="user.email!=''"
						@change="lowerCaseEmail"
					>
						<a-icon slot="prefix" type="mail"/>
					</a-input>
				</a-row>
				<a-row>
					<span class="tr-label">Login:</span>					
					<a-input
						:maxLength=100
						placeholder="Insira o login do usuário. (Ex: nome.sobrenome)"
						v-model="user.login"
						:allowClear="user.login!=''"
						@change="lowerCaseLogin"
					>
						<a-icon slot="prefix" type="team"/>
					</a-input>
				</a-row>
				<a-row>
					<a-col :span="24">
						<span class="tr-label">Tipo Acesso:</span>						
						<a-select
							placeholder="Selecione o tipo acesso do usuário"
							style="width: 100%;"
							:value="valuePerfilPortal"
							@change="handleSelectChange"
						>
							<a-select-option
								v-for="perfilPortal in perfisPortal"
								:key="perfilPortal.idPerfilPortal"
								:value="perfilPortal.idPerfilPortal"
							>{{perfilPortal.descricao}}</a-select-option>
						</a-select>
					</a-col>
				</a-row>
				<a-row v-if="(valuePerfilPortal==3)">
					<span class="tr-label">CNPJ/CPF:</span>					
					<a-input
						:maxLength=20
						placeholder="Insira o CNPJ/CPF"
						v-model="user.cnpj"
						v-ant-input-focus
						:allowClear="user.cnpj!=''"
						>
						<!-- v-mask="'##.###.###/####-##'" -->
						<a-icon slot="prefix" type="user"/>						
					</a-input>
						<!--<a-col :span="24">
							<span class="tr-label">Tipo Perfil:</span>	
							<a-select
								placeholder="Selecione o tipo de crendecial"
								style="width: 100%;"
								v-model="user.tipoPerfil"
								@change="handleSelecttipoPerfilChange"
							>
								<a-select-option
									v-for="tptipoPerfil in tptipoPerfilData"
									:key="tptipoPerfil.key"
									:value="tptipoPerfil.key"
								>{{tptipoPerfil.descricao}}</a-select-option>
							</a-select>
						</a-col>-->
				</a-row>
				
				<span slot="buttons">
					<a-row type="flex" align="middle">
						<a-col :span="12" style="text-align: left;">														
						</a-col>
						<a-col :span="12">
							<a-row type="flex" justify="end" align="middle" :gutter="40">
								<a-col>
									<a-button key="back" class="usuario-form-button" @click.prevent="handleCancelNewUser">Retornar</a-button>
								</a-col>
								<a-col>
									<a-button
										key="submit"
										class="usuario-form-button"
										type="primary"										
										@click.prevent="handleOkNewUser"
									>Salvar</a-button>
								</a-col>
							</a-row>
						</a-col>
					</a-row>					
				</span>
			</modal-component>
		</a-row>
	</div>
</template>

<script>
import PortalCredencialWebApi from "@/API/PortalCredencialWebApi";
import ModalComponent from "@/components/ModalComponent";
import moment from "moment";
import {mask} from 'vue-the-mask';
import { showNotificationError } from "@/util/showNotification";
import { showNotificationSucess } from "@/util/showNotification";
import Helpers from "@/util/Helpers";

// const tpPerfilFornecedorData = [{ key:1, descricao:"Dado" }, { key:2, descricao:"Autos" }];
const tptipoPerfilData = [{ key:1, descricao:"Dado" }, { key:2, descricao:"Autos" }, { key:3, descricao:"Autos/Dado" }];

const columns = [
	{
		title: "Nome",
		dataIndex: "nome",
		sorter: (a, b) => a.nome.localeCompare(b.nome),		
		scopedSlots: { customRender: "nome" }
	},
	{
		title: "Login",
		dataIndex: "login",
		sorter: (a, b) => a.login.localeCompare(b.login),
		width: "18%",
		scopedSlots: { customRender: "login" }
	},
	{
		title: "E-mail",
		dataIndex: "email",
		sorter: (a, b) => a.email.localeCompare(b.email),
		width: "18%",
		scopedSlots: { customRender: "email" }
	},
	{
		title: "Tipo Acesso",
		dataIndex: "perfilPortal.descricao",
		sorter: (a, b) => a.perfilPortal.descricao.localeCompare(b.perfilPortal.descricao),
		width: "10%",
		scopedSlots: { customRender: "perfilPortal" }
	},
	{
		title: "Situação",
		dataIndex: "ativo",
		sorter: (a, b) => a.ativo - b.ativo,		
		align: "center",
		width: "7%",
		scopedSlots: { customRender: "ativo" }
	},	
	{
		key: "IdUsuario",
		title: "Editar",
		dataIndex: "editar",
		align: "center",
		width: "7%",
		scopedSlots: { customRender: "editar" }
	}
];

const columnsSemCliente = [
	{
		title: "Nome",
		dataIndex: "nome",
		sorter: (a, b) => a.nome.localeCompare(b.nome),		
		scopedSlots: { customRender: "nome" }
	},
	{
		title: "Login",
		dataIndex: "login",
		sorter: (a, b) => a.login.localeCompare(b.login),
		width: "22%",
		scopedSlots: { customRender: "login" }
	},
	{
		title: "E-mail",
		dataIndex: "email",
		sorter: (a, b) => a.email.localeCompare(b.email),
		width: "22%",
		scopedSlots: { customRender: "email" }
	},
	{
		title: "Tipo Acesso",
		dataIndex: "perfilPortal.descricao",
		sorter: (a, b) => a.perfilPortal.descricao.localeCompare(b.perfilPortal.descricao),
		width: "15%",
		scopedSlots: { customRender: "perfilPortal" }
	},
	{
		title: "Situação",
		dataIndex: "ativo",
		sorter: (a, b) => a.ativo - b.ativo,		
		align: "center",
		width: "7%",
		scopedSlots: { customRender: "ativo" }
	},
	{
		key: "IdUsuario",
		title: "Editar",
		dataIndex: "editar",
		align: "center",
		width: "7%",
		scopedSlots: { customRender: "editar" }
	}
];

const columnsModal = [	
	{
		title: "Nome",
		dataIndex: "nome",
		sorter: (a, b) => a.nome.localeCompare(b.nome),		
		scopedSlots: { customRender: "nome" }
	},	
	{
		dataIndex: "recebeEmail",
		sorter: (a, b) => a.recebeEmail - b.recebeEmail,
		width: "35%",
		align: "center",
		slots: { title: 'customTitleReceberEmail' },
		scopedSlots: { customRender: "recebeEmail" }
	},
];

export default {	
	directives: {mask},	
	name: "usuario",
	data() {
		return {
			idTela: 1,
			data: [],
			dataModal: [],
			strSearch: null,
			searchText: "",
			searchInput: null,
			pagination: {},
			loading: false,
			columns,
			columnsSemCliente,
			columnsModal,
			user: {
				idUsuario: 0,
				idUsuarioAlteracao: 0,
				idUsuarioCadastro: 0,
				nome: "",
				cnpj: 0,
				login: "",
				email: "",
				senha: "",
				ativo: true,
				idPerfilPortal: 0,
				tipoPerfil: "0",
				perfilPortal: {
					idPerfilPortal: 0,
					descricao: "",
					situacao: ""
				},
				
				primeiroAcesso: 1,
			},
			perfisPortalCompleto: [],
			perfisPortal: [],
			valuePerfilPortal: null,
			valueFornecedor: null,	
			gestorSelRowsModal: null,
			rowSelection: {
				type:'checkbox',
				onChange: (selectedRowKeys, selectedRows) => {					
					this.rowSelection.selectedRowKeys = selectedRowKeys;
					this.gestorSelRowsModal = selectedRows.length == 0 ? null : selectedRows;
				},
				selectedRowKeys: [],
			},
			ehNovoUsuario: true,
			oldAtivoStatus: true,
			textFilter: "",
			showFornecedor: false,
			tptipoPerfilData,

		};
	},
	mounted() {		
		this.showFornecedor = this.$store.state.auth.idPerfilPortal == 1;
		this.fetch({ search: true });
		this.recuperarPerfisPortal();		
	},
	methods: {
		lowerCaseLogin() {
            this.user.login = this.user.login.toLowerCase();
        },
		lowerCaseEmail() {
			this.user.email = this.user.email.toLowerCase();
		},
		habilitarFuncionalidade(funcionalidade) {
			let retorno = Helpers.funcionalidadeAutorizada({
				idTela: this.idTela,
				funcionalidade: funcionalidade
			});
			return retorno;
		},
		handleTableChange(pagination, filters, sorter) {
			const pager = { ...this.pagination };
      		pager.current = pagination.current;
      		this.pagination = pager;
		},	
		handleSelecttipoPerfilChange(value) {
			    this.user.tipoPerfil = value;
		},	
		fetch(params = {}) {
			this.loading = true;
			if (params.search) {
				PortalCredencialWebApi.getUsersExibicao(params).then(res => {
					this.loading = false;
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Usuário", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Usuário", res.data.result);
					} else {
						this.data = res.data.result;
						this.pagination = { current: 1 };
					}
				})
				.catch(res => {
					this.loading = false;
					showNotificationError(this, "Usuário", "Erro ao tentar carregar usuários.");
				});
			} else {
				this.loading = false;
			}
		},
		onSearch(text) {
			this.textFilter = text;
			this.fetch({ search: true, Text: this.textFilter });
		},
		editarUsuario(usuario) {			
			this.ehNovoUsuario = false;
			this.gestorSelRowsModal = null;
			this.perfisPortal = this.$store.state.auth.idPerfilPortal > 1 ? this.perfisPortalCompleto.filter(y => {
				if (this.$store.state.auth.idPerfilPortal == 2)
				{
					return (y.idPerfilPortal == 2 || y.idPerfilPortal == 3);
				}
			}) : this.perfisPortalCompleto;
			this.user.idUsuario = usuario.idUsuario;
			this.user.nome = usuario.nome;
			this.user.login = usuario.login;
			this.user.email = usuario.email;
			this.user.ativo = usuario.ativo;
			this.oldAtivoStatus = usuario.ativo;
			this.user.senha = usuario.senha
			this.user.cnpj = usuario.cnpj
			this.valuePerfilPortal = usuario.idPerfilPortal;
			this.handleSelectChange(usuario.idPerfilPortal);
			let perfilPortal = this.perfisPortal.filter(x => {
				return x.idPerfilPortal == usuario.idPerfilPortal;
			});			
			if (perfilPortal.length > 0) {
				this.user.perfilPortal.idPerfilPortal = perfilPortal[0].idPerfilPortal;
				this.user.perfilPortal.descricao = perfilPortal[0].descricao;
				this.user.perfilPortal.situacao = perfilPortal[0].situacao;
			}			
			
			this.user.statusTermoUso = usuario.statusTermoUso;
			this.user.tipoPerfil = usuario.tipoPerfil;		
			this.$refs.modaluser.showModal();
		},
		onNewUsuario() {
			this.ehNovoUsuario = true;
			this.handleCancelNewUser();
			this.perfisPortal = this.$store.state.auth.idPerfilPortal > 1 ? this.perfisPortalCompleto.filter(y => {
				if (this.$store.state.auth.idPerfilPortal == 2)
				{
					return (y.idPerfilPortal == 2 || y.idPerfilPortal == 3);
				}
			}) : this.perfisPortalCompleto;
			this.valuePerfilPortal = null;

			this.$refs.modalnewuser.showModal();
		},
		recuperarPerfisPortal() {
			PortalCredencialWebApi.getPerfisPortal().then(res => {
				this.perfisPortalCompleto = res.data.result;
				this.perfisPortal = res.data.result;
			});
		},
		handleSelectChange(value) {			
			this.valuePerfilPortal = value;	
			
			let perfilPortal = this.perfisPortal.find(p => {
				return p.idPerfilPortal == value;
			});
			this.user.perfilPortal = perfilPortal;
		},
		handlerSwitchChange(value) {
			this.user.ativo = value;
		},
		validarCampos(user){
			let camposValidos = true;			

			if (this.user.nome.trim() == "") {
				showNotificationError(this, "Cadastro de Usuário", "Nome é um campo obrigatório!");
				camposValidos = false;
			} else if (this.user.email.trim() == "") {
				showNotificationError(this, "Cadastro de Usuário", "Email é um campo obrigatório!");
				camposValidos = false;
			} else if (!Helpers.validarEmail(this.user.email.trim())) {
				showNotificationError(this, "Cadastro de Usuário", "Email com formato inválido!");
				camposValidos = false;
			} else if (this.user.login.trim() == "") {
				showNotificationError(this, "Cadastro de Usuário", "Login é um campo obrigatório!");
				camposValidos = false;
			} else if ((this.user.perfilPortal == undefined) || (this.user.perfilPortal == null) || (this.user.perfilPortal.idPerfilPortal == 0)) {
				showNotificationError(this, "Cadastro de Usuário", "Tipo acesso é um campo obrigatório!");
				camposValidos = false;
			} else if ((this.user.cnpj <= 0) && (this.user.perfilPortal == 3)) {
				showNotificationError(this, "Cadastro de Usuário", "CNPJ/CPF/OAB é um campo obrigatório!");
				camposValidos = false;
			} 
			return camposValidos
		},
		handleOkEditUser() {			
			if (!this.validarCampos(this.user)){
				return;
			};
			
			if ((this.oldAtivoStatus == true) && (this.user.ativo == false)) {
				const _this = this;
				const x = _this.$createElement;				
				this.$confirm({				
					title: x('div', {}, [
							x('p', "Atenção! todas as credenciais ligadas a esse perfil serão excluídas."),
						]),					
					content: h => <div style="font-size: 16px; color: #000000d9;">Deseja continuar?</div>,
					okText: 'Sim',        			
        			cancelText: 'Não',
					width: '25%',
					onOk() {
						_this.chamarAPIEditarUsuario();
					},
					onCancel() {},
				});
			} else {
				this.chamarAPIEditarUsuario();
			}
		},
		chamarAPIEditarUsuario() {
			this.$root.loadingSpinner = true;
			this.user.idPerfilPortal = this.user.perfilPortal.idPerfilPortal;
			this.user.idUsuarioAlteracao = this.$store.state.auth.idUser;
			

			PortalCredencialWebApi.atualizarUsuario(this.user, this.$store.state.auth.idUser)
				.then(res => {
					this.handleCancelEditUser();
					this.$root.loadingSpinner = false;
					if (res.data.statusCode == 200) {
						showNotificationSucess(this, "Cadastro de Usuário", res.data.result);
						this.fetch({ search: true, Text: this.textFilter });
						this.recuperarPerfisPortal();						
					} else
						showNotificationError(this, "Cadastro de Usuário", res.data.errorMessage);
				})
				.catch(res => {
					this.$root.loadingSpinner = false;
					this.loading = false;
					showNotificationError(this, "Cadastro de Usuário", "Erro ao tentar editar usuário.");
				});
		},
		handleCancelEditUser() {			
			this.$refs.modaluser.handleCancel();
			this.user.idUsuario = 0;
			this.user.idUsuarioAlteracao = 0,
			this.user.idUsuarioCadastro = 0,
			this.user.nome = "";
			this.user.login = "";
			this.user.email = "";
			this.user.senha = "";
			this.user.cnpj = "";
			this.user.ativo = true;
			this.user.idPerfilPortal = null;
			this.user.tipoPerfil = "";
			this.gestorSelRowsModal = null;
			this.rowSelection.selectedRowKeys = [];
			this.dataModal = [];
		},
		handleOkNewUser() {
			if (!this.validarCampos(this.usuario)){
				return;
			}

			this.$root.loadingSpinner = true;
			this.user.idPerfilPortal = this.user.perfilPortal.idPerfilPortal;			
			this.user.idUsuarioCadastro = this.$store.state.auth.idUser;
			this.user.ativo = true;
			this.user.tipoPerfil = "0"
			PortalCredencialWebApi.inserirUsuario(this.user)
				.then(res => {
					this.$refs.modalnewuser.handleCancel();
					this.$root.loadingSpinner = false;
					if (res.data.statusCode == 200) {
						showNotificationSucess(this, "Cadastro de Usuário", res.data.result);
					} else {
						showNotificationError(this, "Cadastro de Usuário", res.data.errorMessage);
					}					
					this.fetch({ search: true, Text: this.textFilter });
					this.recuperarPerfisPortal();					
				})
				.catch(res => {
					this.$root.loadingSpinner = false;
					this.loading = false;
					showNotificationError(this, "Cadastro de Usuário", "Erro ao tentar inserir usuário.");
				});
		},
		handleCancelNewUser() {
			this.$refs.modalnewuser.handleCancel();
			this.user.idUsuario = 0;
			this.user.idUsuarioAlteracao = 0,
			this.user.idUsuarioCadastro = 0,
			this.user.nome = "";
			this.user.login = "";
			this.user.email = "";
			this.user.senha = "";
			this.user.cnpj = "";
			this.user.ativo = true;
			this.user.tipoPerfil = "";
			this.gestorSelRowsModal = null;
			this.user.statusTermoUso = 0;
			this.rowSelection.selectedRowKeys = [];
			this.dataModal = [];
		},
		handleChangeRecebeEmail(gestor){
			gestor.recebeEmail = !gestor.recebeEmail;			
		}
	},
	components: { ModalComponent }
};
</script>

<style scoped>
span {
	color: #000;
	font-family: "Segoe UI", "Segoe UI Emoji", "Segoe UI Symbol", "Courier New",
		Courier, monospace;
	font-weight: bold;
}

.ant-select {
	margin: 0px 0px 10px 0px;
}

.ant-switch {
	margin: 10px 0px 10px 0px;
}

.ant-input-affix-wrapper {
	margin: 0px 0px 10px 0px;
} 

.danger {
	color: red;
}

.sucess {
	color: green;
}

.default {
	color: black;
}

.custom-filter-dropdown {
	padding: 8px;
	border-radius: 4px;
	background: #fff;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
	background-color: rgb(255, 192, 105);
	padding: 0px;
}

.cursor {
	cursor: pointer;
}

.cursor:hover {
  color: blue;
}
</style>

<style>
.usuario-form-button {
	width: 100px;
}
</style>